import { TravelMode, TRAVEL_MODES } from "./enums";

/**
 * What a single-day (day pass) registration includes, as opposed to a full-event
 * registration.
 *
 * The distinction is really "is this registrant staying overnight" — day-pass
 * holders are not, which is why they get no t-shirt and cannot answer RV/Camper.
 *
 * These rules must hold identically in the registration wizard, the admin
 * add/edit form, and server-side validation, so they live here rather than being
 * re-implemented at each site.
 */

/** Travel modes that imply sleeping on site, so unavailable to day-pass registrants. */
const OVERNIGHT_TRAVEL_MODES: TravelMode[] = [TravelMode.RvCamper];

/** The travel modes offered for this kind of registration. */
export function travelModesFor(isDayPass: boolean): TravelMode[] {
  if (!isDayPass) return TRAVEL_MODES;
  return TRAVEL_MODES.filter((mode) => !OVERNIGHT_TRAVEL_MODES.includes(mode));
}

/** Whether a t-shirt is part of this kind of registration. */
export function includesTshirt(isDayPass: boolean): boolean {
  return !isDayPass;
}
